import { Box } from '@mui/material'
import MetricsSummaryCard from './MetricsSummaryCard'
import GoogleIcon from '../../../../icon/GoogleIcon'
import { METRICS_SUMMARY_GRID_SX } from '../../style/metricsIndexStyles'

export default function MetricsSummary({ cards = [] }) {
  return (
    <Box sx={METRICS_SUMMARY_GRID_SX}>
      {cards.map(card => (
        <MetricsSummaryCard
          key={card.key}
          title={card.title}
          subtitle={card.subtitle}
          value={card.value}
          chipLabel={card.chip}
          chipClass={card.chipClass}
          icon={
            <GoogleIcon
              name={card.icon}
              size={18}
              filled={card.iconFilled}
              className="oc-icon-primary"
            />
          }
        />
      ))}
    </Box>
  )
}
